// CSV + branded PDF exporters for the JC3 Wealth Legacy Group dashboard.
// CSV downloads via Blob; PDF opens a print-styled new window with Private Room palette.
import { BUSINESS, addressSingleLine } from "../config/business";

const cell = (v) => {
  if (v === null || v === undefined) return "";
  if (typeof v === "string") return v;
  if (Array.isArray(v)) return v.join("; ");
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
};

const csvEscape = (v) => {
  const s = cell(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

export const downloadCSV = (filename, columns, rows) => {
  const head = columns.map((c) => csvEscape(c.label)).join(",");
  const body = rows
    .map((r) => columns.map((c) => csvEscape(typeof c.get === "function" ? c.get(r) : r[c.key])).join(","))
    .join("\n");
  const blob = new Blob([`\ufeff${head}\n${body}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const printPDF = (title, columns, rows, target) => {
  const ths = columns
    .map((c) => `<th style="background:#E7DDCB;color:#5E4D40;text-align:left;padding:8px 10px;font-family:'Hanken Grotesk',sans-serif;font-weight:500;letter-spacing:.1em;font-size:11px;text-transform:uppercase;border-bottom:1px solid rgba(42,28,21,.18);-webkit-print-color-adjust:exact;print-color-adjust:exact;">${c.label}</th>`)
    .join("");
  const trs = rows
    .map((r) => {
      const tds = columns
        .map((c) => {
          const v = typeof c.get === "function" ? c.get(r) : r[c.key];
          const safe = cell(v).replace(/</g, "&lt;").replace(/>/g, "&gt;");
          return `<td style="padding:6px 10px;font-family:'Hanken Grotesk',sans-serif;font-variant-numeric:tabular-nums;font-size:11px;color:#2A1C15;border-bottom:1px solid rgba(42,28,21,.18);">${safe}</td>`;
        })
        .join("");
      return `<tr>${tds}</tr>`;
    })
    .join("");
  const now = new Date().toLocaleString("en-US", { dateStyle: "long", timeStyle: "short" });
  const html = `<!doctype html>
<html><head><title>${title} — ${BUSINESS.shortName}</title>
<link href="https://fonts.googleapis.com/css2?family=Libre+Caslon+Display&family=Hanken+Grotesk:wght@400;500&display=swap" rel="stylesheet">
<style>
  @page { size: A4 landscape; margin: 18mm; }
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
  body { font-family: 'Hanken Grotesk', sans-serif; color: #2A1C15; margin: 0; padding: 24px; background: #DCCFB9; }
  .bar { background:#14281E; color:#F2EBDD; padding:16px 22px; border-bottom:1px solid rgba(200,164,106,.45); margin: -24px -24px 18px; display:flex; justify-content:space-between; align-items:center; }
  .brand img { height: 28px; display:block; }
  .meta { font-size: 10px; color: #BDB6A6; letter-spacing: .14em; text-transform: uppercase; }
  h1 { font-family: 'Libre Caslon Display', serif; font-weight:400; text-transform: uppercase; letter-spacing: .04em; font-size: 30px; color: #2A1C15; margin: 8px 0 16px; }
  table { width:100%; border-collapse: collapse; background:#E7DDCB; }
  
  .footer { margin-top: 22px; font-size: 10px; color: #5E4D40; letter-spacing:.16em; text-transform:uppercase; }
</style></head>
<body>
  <div class="bar">
    <div class="brand"><img src="https://www.jc3wealthlegacy.com/jc3-logo-horizontal-on-dark.svg" alt="${BUSINESS.shortName}" /></div>
    <div class="meta">${now}</div>
  </div>
  <h1>${title}</h1>
  <table><thead><tr>${ths}</tr></thead><tbody>${trs}</tbody></table>
  <div class="footer">© 2026 ${BUSINESS.legalName} · ${addressSingleLine()} · ${BUSINESS.phone} · ${BUSINESS.website}</div>
  <script>window.onload = () => setTimeout(() => window.print(), 350);</script>
</body></html>`;
  const w = target || window.open("", "_blank", "noopener,noreferrer,width=1200,height=800");
  if (!w) {
    alert("Pop-up blocked. Allow pop-ups for jc3wealthlegacy.com to export PDFs.");
    return;
  }
  w.document.open();
  // Safer than a raw document.write() with user-adjacent HTML: we've already
  // HTML-escaped every cell value on the way in (see `.replace(/</g,"&lt;")`),
  // and every remaining template literal in `html` is sourced from our own
  // trusted BUSINESS config. Using open/write/close on the *new* window (not
  // the parent) also isolates any injection risk from the dashboard shell.
  w.document.write(html);
  w.document.close();
};
